<template>
    <v-chip
        v-on="$listeners"
        :x-small="size === 'x-small'"
        :small="size === 'small'"
        :class="[decoratorClass, textColorClass]"
        :dark="isDark"
        :style="'background-color: ' + bgColor"
    >
        <v-icon v-if="icon" :size="iconSize" class="mr-1" :color="iconColor">{{ icon }}</v-icon>
        <slot />
    </v-chip>
</template>

<script>
    // Atomicka typova pilulka (2026-08-06, docs/superpowers/specs/2026-08-06-
    // shared-type-ui-components-design.md) - nahrazuje rucne skladany v-chip
    // s :dark="textColors[...]" na ~15 mistech v appce. Barva pozadi/textu/
    // ikony se pocita JEDNOU tady, ne na kazdem miste pouziti zvlast - presne
    // tohle bylo zdrojem opakovaneho bugu (zapomenuta vlastni black--text/
    // white--text trida, zapomenuta barva ikony).
    //
    // Obsah pilulky (text) NENI soucasti komponenty - jde pres default slot,
    // protoze ruzna mista dnes legitimne zobrazuji jiny text (type.id v
    // pickerech, type.name v tabulkach) - to je obsahovy rozdil, ne bug.
    //
    // v-on="$listeners" na v-chip (2026-08-06, nalez finalniho review) -
    // volajici (napr. TrainerFightWinNext.vue) posilaji v-on="on" z
    // v-tooltip activator slotu primo na TypePill. Bez explicitniho
    // predani by tyhle listenery skoncily jako komponentove $listenery na
    // TypePill samotne a nikdy se nedostaly na skutecny DOM element -
    // puvodni holy v-chip fungoval jen diky tomu, ze Vuetify VChip ma
    // vlastni routable mixin, ktery tohle dela interne.
    //
    // `disabled` prop odstranen (2026-08-07, nalez finalniho review) - byl
    // nepouzity NIKDE v appce a navic mel skryty bug: prepnul jen bgColor
    // na TYPE_GREY_COLORS, ale isDark/textColorClass/iconColor dal cetly
    // TYPE_DARK_THEME (svitivostni mapa kalibrovana na plnou sytou paletu),
    // takze u nekterych typu (napr. ICE, ULTIMATE) by vyslo spatne barevny
    // text na sedive pilulce. Kdyby v budoucnu byl potreba "sedivy/
    // nekoupeny" stav pilulky, potrebuje vlastni svitivostni logiku pro
    // sedivou paletu, ne jen prepnuti barvy pozadi.
    import {TYPE_COLORS, TYPE_DARK_THEME} from '@/utils/typeColorEnum';

    export default {
        name: 'TypePill',
        props: {
            type: {type: Object, required: true},
            icon: {type: String, default: null},
            size: {
                type: String,
                default: 'default',
                validator: (v) => ['x-small', 'small', 'default'].includes(v),
            },
        },
        computed: {
            isDark() {
                return TYPE_DARK_THEME[this.type.id];
            },
            bgColor() {
                return TYPE_COLORS[this.type.id];
            },
            textColorClass() {
                return this.isDark ? 'white--text' : 'black--text';
            },
            iconColor() {
                return this.isDark ? 'white' : 'black';
            },
            iconSize() {
                return {'x-small': 12, 'small': 14, 'default': 16}[this.size];
            },
            decoratorClass() {
                const small = this.size !== 'default' ? '-small' : '';
                return this.isDark ? `chip-dekorator-white${small}` : `chip-dekorator-dark${small}`;
            },
        },
    }
</script>
